export type CashflowViewPreference = "cashflow" | "budget";

const CASHFLOW_VIEW_PREFERENCE_KEY = "cashflowDefaultView";
export const CASHFLOW_VIEW_PREFERENCE_CHANGED_EVENT =
  "cashflow-default-view-changed";

export function readCashflowViewPreference(): CashflowViewPreference {
  if (typeof window === "undefined") return "cashflow";
  return window.localStorage.getItem(CASHFLOW_VIEW_PREFERENCE_KEY) === "budget"
    ? "budget"
    : "cashflow";
}

export function writeCashflowViewPreference(
  view: CashflowViewPreference
): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(CASHFLOW_VIEW_PREFERENCE_KEY, view);
  window.dispatchEvent(
    new CustomEvent(CASHFLOW_VIEW_PREFERENCE_CHANGED_EVENT, {
      detail: view,
    })
  );
}
